/** @format */

import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import classNames from 'classnames';
import InputLabel from '@material-ui/core/InputLabel';
import I18n from '../Translate/I18n';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

const useStyle = makeStyles(adescomStyle);

type CustomInputCurrencyType = {
    error?: any;
    success?: any;
    white?: any;
    inputRootCustomClasses?: any;
    formControlProps?: any;
    labelProps?: any;
    inputProps?: any;
    labelText?: string | null;
    required?: boolean | null;
    helpText?: string | null;
    name?: string | null;
    value?: string | number | null;
    decimalLimit?: number | null;
    id?: string | null;
    onClickEvent?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeEvent?: (field: string, value: number | null) => void;
    allowNegaitve?: boolean;
};

export const CustomInputCurrency: FunctionComponent<CustomInputCurrencyType> = ({
    error,
    success,
    white,
    inputRootCustomClasses,
    formControlProps,
    labelProps,
    inputProps,
    labelText,
    required,
    helpText,
    id,
    onClickEvent,
    onChangeEvent,
    name,
    value,
    decimalLimit,
    allowNegaitve,
}): React.ReactElement => {
    const classes = useStyle();
    const [currency, setCurrency] = useState<string>('');
    const changeDotToComma = useCallback((value?: string | number | null): string => {
        if (!value) {
            return '';
        }
        let newValue = '';
        if (typeof value === 'number') {
            newValue = value.toString();
        } else {
            newValue = value;
        }
        return newValue.replace('.', ',');
    }, []);

    useEffect(() => {
        setCurrency(changeDotToComma(value));
    }, [value, changeDotToComma]);

    const labelClasses = classNames({
        [' ' + classes.labelRootError]: error,
        [' ' + classes.labelRootSuccess]: success && !error,
    });
    const underlineClasses = classNames({
        [classes.underlineError]: error,
        [classes.underlineSuccess]: success && !error,
        [classes.underline]: true,
        [classes.whiteUnderline]: white,
    });
    const marginTop = classNames({
        [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
    });
    const inputClasses = classNames({
        [classes.input]: true,
        [classes.whiteInput]: white,
    });
    const formControlClasses = classes.formControl;

    const helpTextClasses = classNames({
        [classes.labelRootError]: error,
        [classes.labelRootSuccess]: success && !error,
    });

    const onChangeLocalEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        let value = event.target.value;
        const field = event.target.name;
        if (!allowNegaitve) {
            value = value.replace(/[^0-9,]/g, '').replace(/(,.*?),.*/g, '$1');
        } else {
            value = value.replace(/[^0-9,-]/g, '').replace(/(,.*?),.*/g, '$1');
        }
        setCurrency(value);
        if (onChangeEvent) {
            onChangeEvent(field, parseFloat(value.replace(',', '.')));
        }
    };

    return (
        <FormControl {...formControlProps} className={formControlClasses} fullWidth={true}>
            {labelText && (
                <InputLabel className={classes.labelRoot + ' ' + labelClasses} htmlFor={id} {...labelProps}>
                    {required ? <I18n trans={labelText} asterisk={true} /> : <I18n trans={labelText} />}
                </InputLabel>
            )}
            <Input
                classes={{
                    input: inputClasses,
                    root: marginTop,
                    disabled: classes.disabled,
                    underline: underlineClasses,
                }}
                id={id}
                onChange={onChangeLocalEvent}
                onClick={onClickEvent}
                name={name}
                value={currency}
                {...inputProps}
            />
            {helpText && (
                <FormHelperText id={id + '-text'} className={helpTextClasses}>
                    <I18n trans={helpText} />
                </FormHelperText>
            )}
        </FormControl>
    );
};
